import { routes as auth } from '../modules/auth'
import { routes as home } from '../pages/home'
import dashboards from '@/modules/dashboards/routes'
import { routes as users } from '../pages/users'
import { routes as roles } from '../pages/roles'
import { routes as languages } from '../pages/languages'
import { routes as translations } from '../pages/translations'
import { routes as event } from '../pages/event'
import { routes as emailTemplate } from '../pages/event/email'
import { routes as speaker } from '../pages/speakers'
import { routes as schedule } from '../pages/schedules'
import { routes as room } from '../pages/rooms'
import { routes as partner } from '../pages/partners'
import { routes as participant } from '../pages/participants'
import { routes as report } from '../pages/reports'
import { routes as survey } from '../pages/survey'
import { routes as gamification } from '../pages/gamification'
import { routes as archive } from '../pages/archives'
import { routes as video } from '../pages/videos'
import { routes as videoCategory } from '../pages/video-categories'
import { routes as partnerCategory } from '../pages/partner-categories'
import { routes as videoComment } from '../pages/video-comments'
import { routes as timelinebanner } from '../pages/event/timelineBanners'
import { routes as lobbybanner } from '../pages/event/lobbyBanners'
import { routes as raffle } from '../pages/raffle'
import { routes as campaign } from '../pages/wa/campaign'
import { routes as ecampaign } from '../pages/email/campaign'
import { routes as template } from '../pages/event/wa/templates'
import { routes as wa } from '../pages/event/wa'
import { routes as formBuilder } from '../pages/form-builder'
import { routes as customList } from '../pages/custom-lists'

export default [
  ...auth,
  ...home,
  ...dashboards,
  ...users,
  ...roles,
  ...languages,
  ...translations,
  ...event,
  ...speaker,
  ...schedule,
  ...room,
  ...participant,
  ...report,
  ...survey,
  ...gamification,
  ...archive,
  ...raffle,
  ...partner,
  ...partnerCategory,
  ...video,
  ...videoCategory,
  ...videoComment,
  ...timelinebanner,
  ...lobbybanner,
  ...emailTemplate,
  ...campaign,
  ...ecampaign,
  ...template,
  ...wa,
  ...formBuilder,
  ...customList
]
